import { Modal } from "@mui/material";
import React from "react";
import { IoCloseCircle } from "react-icons/io5";
import FiberCompanySelector from "../../../../../components/FiberCompanySelector";
import Swal from "sweetalert2";
const GoogleReviewsModal = ({ open, setOpen }) => {
  const [fiberCompanyObject, setFiberCompanyObject] = React.useState(null);

  const handleShowGoogleReviews = (companyId) => {
    console.log("companyId", companyId);
    if (!companyId) {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Please select a company",
            confirmButtonText: "Ok",
        });

        return;
    }

   
    if (companyId == "2") {
      window.open(
        "https://www.google.com/search?hl=en-PK&gl=pk&q=Lightcurve+Internet,+2516+S+Holgate+St,+Tacoma,+WA+98402,+United+States&ludocid=2459777209135860675&lsig=AB86z5ViNcwmSuZXrwgvXdegJMUf#lrd=0x5490557b477efcd7:0x2222e256d9250bc3,1"
      );
    }
    else if (companyId == "10" || companyId == "11") {
      window.open(
        "https://www.google.com/search?hl=en-PK&gl=pk&q=Point+Broadband,+617+E+Lake+St,+Stanton,+MI+48888,+United+States&ludocid=7144594975754161850&lsig=AB86z5VU_LnJhMlbV4JE-uHLCAzK#lrd=0x88189a3009599bab:0x6326b346d9de0eba,1"
      );
    } else if (companyId == "12") {
      window.open(
        "https://www.google.com/search?hl=en-PK&gl=pk&q=Wyyerd+Fiber,+401+Mile+of+Cars+Way+Suite+101,+National+City,+CA+91950,+United+States&ludocid=11988194643357665407&lsig=AB86z5V-y0q3CIOy_pRmtOt0mxPK#lrd=0x80d953b37d40352f:0xa65e9f830f93087f,1"
      );
    } 
    else if (companyId == "15") {
        window.open(
                "https://www.google.com/search?sca_esv=e22de9d06ec1c45e&sxsrf=AHTn8zphtQSe7NAReus5D9I13oEvid1gzA:1746663421974&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzUosifN0XUCefax72SI3yAFZwjjiHYIQDns4jmWcdHRZUP-HTUsDP8XXQyO9VK6ZOwMzlE08mpQzOZz3AjSmh9t_2HaE&q=Ezee+Fiber+Reviews&sa=X&ved=2ahUKEwjAkbymzJKNAxUrgf0HHd1QAI8Q0bkNegQIKhAE&biw=1920&bih=893&dpr=1#lrd=0x8640cb62aace657d:0x201853f941c72fff,1,,,,"
        )
    }
    else {
      window.open(
        "https://www.google.com/search?hl=en-PK&gl=pk&q=Lightning+OS&ludocid=16028841167989401801&lsig=AB86z5XEObcXJKPBrHERurgCg0_G#lrd=0xa3e3000ed4ba87d3:0xde71e21e2b2a68c9,1,,,,"
      );
    }
  };
  return (
    <Modal setOpen={setOpen} open={open} onClose={() => setOpen(false)}>
      <div  style={{overflow:"unset"}} className="custom_modal">
        <IoCloseCircle
          onClick={() => {
            setOpen(false);
          }}
          size={30}
          style={{ marginLeft: "auto", cursor: "pointer" }}
          color="#2761d0"
        />

        <h2 className="text-center">Google Reviews</h2>
        <div className="inputs relative">
          <FiberCompanySelector
            // value={fiberCompanyObject}
            setUser={setFiberCompanyObject}
            setCompanyObject={setFiberCompanyObject}
            placeholder="Select a Company"
            className="fiber_company_selector relative"
            companiesWithOfferTemplateOnly={true}
          />
        </div>
        <div className="d-flex justify-content-center mt-3">
          <button
            onClick={() => {
              setOpen(false);
              handleShowGoogleReviews(fiberCompanyObject?.id);
            }}
            className="btn btn-primary"
          >
            Show Reviews
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GoogleReviewsModal;
